function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { scaleOrdinal } from 'd3-scale';
import { Record, Map, List } from 'immutable';
import { pickBy } from 'ramda';
import { GROUPINGS } from './access-consents';
var FLAG_NAMES = ['ACTIVE', 'TPP_SUSPENDED', 'TPP_CLIENT_SUSPENDED', 'TPP_REVOKED'];
var FLAGS = FLAG_NAMES.reduce(function (groupings, grouping) {
  return Object.assign({}, groupings, _defineProperty({}, grouping, grouping));
}, {});
var removeUndefined = pickBy(function (prop) {
  return prop !== undefined;
});
var TPP = Record({
  tppId: 'TPP ID IS MISSING',
  clientId: 'CLIENT ID IS MISSING',
  clientName: 'the Service Provider',
  agentName: '',
  tppName: 'the Service Provider',
  clientDisplayName: '',
  flag: 'ACTIVE',
  consents: Map(),
  avatarColour: '#707070'
});
function tppFlagOptions(consents) {
  var withGrouping = function withGrouping(grouping) {
    return function (access) {
      return access.get('accessGrouping') === grouping;
    };
  };
  if (consents.some(withGrouping(GROUPINGS.TPP_SUSPENDED))) {
    return {
      flag: 'TPP_SUSPENDED'
    };
  } else if (consents.some(withGrouping(GROUPINGS.TPP_CLIENT_SUSPENDED))) {
    return {
      flag: 'TPP_CLIENT_SUSPENDED'
    };
  } else if (consents.some(withGrouping(GROUPINGS.TPP_REVOKED))) {
    return {
      flag: 'TPP_REVOKED'
    };
  }
  return {};
}
function addAvatarColour(colourByName) {
  return function (name) {
    return {
      avatarColour: colourByName(name)
    };
  };
}
function buildRecordForTPP(avatarColourOptions) {
  return function (consents) {
    var _consents$first$toJS = consents.first().toJS(),
      tppId = _consents$first$toJS.tppId,
      clientId = _consents$first$toJS.clientId,
      clientName = _consents$first$toJS.clientName,
      agentName = _consents$first$toJS.agentName,
      channelId = _consents$first$toJS.channelId;
    var tppRecord = new TPP(removeUndefined(_objectSpread(_objectSpread({
      tppId: tppId,
      clientId: clientId,
      clientName: clientName,
      agentName: agentName,
      clientDisplayName: getClientNameText(clientName, agentName, channelId),
      consents: consents.groupBy(function (access) {
        return access.get('id');
      }).map(function (list) {
        return list.first();
      })
    }, tppFlagOptions(consents)), avatarColourOptions(agentName || clientName))));
    return tppRecord;
  };
}
function getAvatarState(tpp) {
  switch (tpp.get('flag')) {
    case FLAGS.TPP_SUSPENDED:
    case FLAGS.TPP_CLIENT_SUSPENDED:
      return 'SUSPENDED';
    case FLAGS.TPP_REVOKED:
      return 'REVOKED';
    default:
      return '';
  }
}
function getPriorityLabel(flag) {
  switch (flag) {
    case FLAGS.TPP_SUSPENDED:
    case FLAGS.TPP_CLIENT_SUSPENDED:
      return 'Suspended';
    case FLAGS.TPP_REVOKED:
      return 'Revoked';
    default:
      return 'Active';
  }
}
var collateTPPs = function collateTPPs(consents) {
  var avatarColours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : List();
  return consents.groupBy(function (access) {
    return access.get('clientId');
  }).map(buildRecordForTPP(addAvatarColour(scaleOrdinal().range(avatarColours.toJS())))).sortBy(function (tpp) {
    return tpp.get('clientDisplayName');
  });
};
export function getClientName(data) {
  var defaultClientName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'the Service Provider';
  if (!data) {
    return defaultClientName;
  }
  var clientName = data.get('clientName', defaultClientName);
  var agentName = data.get('agentName');
  var channelId = data.get('channelId', '');
  return getClientNameText(clientName, agentName, channelId);
}
export function getClientNameText(clientName, agentName) {
  var channelId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (channelId.includes('VRP') || channelId.includes('PISP')) {
    return agentName ? "".concat(clientName, " via ").concat(agentName) : clientName;
  }
  return agentName ? "".concat(agentName, " on behalf of ").concat(clientName) : clientName;
}
export function getMerchantName(data) {
  var defaultClientName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'the Service Provider';
  var merchantName = data.getIn(['aispDetails', 'merchantName']);
  var clientName = data.get('clientName', defaultClientName);
  return getMerchantNameText(merchantName, clientName);
}
function getMerchantNameText(merchantName, clientName) {
  return merchantName ? "".concat(merchantName, " via ").concat(clientName) : clientName;
}
export { FLAGS, collateTPPs, getAvatarState, getPriorityLabel };